import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import {
	getLocalStorageItem,
	registerFavoritesChangeCallback,
	removeFavoritesChangeCallback,
} from '@swisslife/shared-ui/src/utils/local-storage/js/local-storage';

enum Selectors {
	linkCount = '.a-link__count',
}

// The @Component decorator will connect the class with `data-g-name="FavoriteLink"` elements.
@Component('FavoriteLink')
export class FavoriteLink extends GondelJqueryComponent {
	public sync() {
		this.updateFavoriteCount();

		registerFavoritesChangeCallback(this.updateFavoriteCount);
	}

	public stop() {
		removeFavoritesChangeCallback(this.updateFavoriteCount);
	}

	private updateFavoriteCount = () => {
		const localStorageName = this.$ctx.data('local-storage-name');
		const amountOfFavorites = getLocalStorageItem(localStorageName).length;
		this.$ctx.find(Selectors.linkCount).text(amountOfFavorites.toString());
	};
}
